<footer class="flex px-4 py-8 border-t border-silver bg-white md:py-10 md:justify-center">
  <div
    class="grid w-full max-w-[77rem] text-body-regular md:grid-cols-[auto_1fr_13.125rem] md:grid-rows-2 md:text-caption-regular"
  >
    <div class="md:col-start-1">
      <img src="assets/images/logo-enerix-gray.svg" alt="Enerix logo" class="min-w-24 md:min-w-8" />
    </div>
    <div class="mt-10 md:mt-0 md:row-span-full md:col-start-2 md:flex md:items-end md:justify-self-center">
      <ul class="flex flex-col gap-4 md:flex-row md:gap-10">
        <li>
          <a href="/imprint" class="hover:underline">{{ 'footer.links.imprint' | translate }}</a>
        </li>
        <li>
          <a href="https://www.enerix.de/nutzungsbedingungen-kundenportal" class="hover:underline">{{
            'footer.links.termFirst' | translate
          }}</a>
        </li>
        <li>
          <a href="https://www.enerix.de/datenschutz" class="hover:underline">{{
            'footer.links.termSecond' | translate
          }}</a>
        </li>
      </ul>
    </div>
    <div class="mt-10 md:row-span-full md:col-start-3 md:mt-0 max-w-[14.813rem]">
      <p class="text-caption-semibold">{{ 'footer.badges-label' | translate }}</p>
      <div class="grid grid-cols-3-auto gap-6 mt-4">
        <img
          src="assets/images/image-footer-1.svg"
          alt="Proven Expert distinction for leading service provider."
          class="min-w-12"
        />
        <img
          src="assets/images/image-footer-2.svg"
          alt="Proven Expert distinction for top recommendation."
          class="min-w-12"
        />
        <img src="assets/images/image-footer-3.svg" alt="Deutschland macht's effizient." class="min-w-[3.563rem]" />
      </div>
    </div>
    <p class="text-xs mt-10 md:col-start-1 md:flex md:items-end md:mt-0">
      {{ 'footer.copyright' | translate : { currentYear: currentYear } }}
    </p>
  </div>
</footer>
